import { Menu, MenuItem, ButtonBase } from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import { useState } from 'react'

import { getTranslate } from '../../localization'
import useStyles from './styles/MonitoringRowMenu.styles'

interface MonitoringRowMenuProps {
  viewRequest: () => void
  viewResponse: () => void
}
const MonitoringRowMenu: React.FC<MonitoringRowMenuProps> = ({
  viewRequest,
  viewResponse
}) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <ButtonBase onClick={handleClick} className={classes.moreIcon}>
        <MoreIcon />
      </ButtonBase>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <MenuItem onClick={viewRequest}>
          {getTranslate('View Request')}
        </MenuItem>
        <MenuItem onClick={viewResponse}>
          {getTranslate('View Response')}
        </MenuItem>
      </Menu>
    </>
  )
}
export default MonitoringRowMenu
